<template>
  <div>
    <div v-for="(item,index) in drawList" @click="clickType(index,item)" :class="{'actived':currentIndex==index?true:false}" :title="item.label" class="left-type">
      <i :class="item.icon" class="iconfont"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: 'onLinePSLeft',
  data() {
    return {
      currentIndex: -1,
      drawTypeDraw: [
        {
          icon: 'icon-icon_xuanze',
          label: '选择',
          key: 'select',
          type:'select'
        },
        {
          icon: 'icon-icon_huabi',
          label: '笔',
          key: 'pen',
          type:'pen'
        },
        {
          icon: 'icon-px-1',
          label: '箭头',
          key: 'arrow',
          type:'arrow'
        },
        {
          icon: 'icon-icon_zhixian',
          label: '线',
          key: 'line',
          type:'line'
        },
        {
          icon: 'icon-icon_xuxian',
          label: '虚线',
          key: 'dottedline',
          type:'dottedline'
        },
        {
          icon: 'icon-icon_yuan1',
          label: '圆',
          key: 'circle',
          type:'circle'
        },
        {
          icon: 'icon-icon_tuoyuan',
          label: '椭圆',
          key: 'ellipse',
          type:'ellipse'
        },
        {
          icon: 'icon-icon_fang1',
          label: '矩形',
          key: 'rectangle',
          type:'rectangle'
        },
        {
          icon: 'icon-icon_sanjiao1',
          label: '三角形',
          key: 'triangle',
          type:'triangle'
        },
        {
          icon: 'icon-wenzi',
          label: '文字',
          key: 'text',
          type:'text'
        },
        {
          icon: 'icon-icon_yuan',
          label: '球标圆',
          key: 'circle',
          isSign:true,
          type:'signCircle'
        },
        {
          icon: 'icon-icon_sanjiao',
          label: '球标三角形',
          key: 'triangle',
          isSign:true,
          type:'signTriangle'
        },
        {
          icon: 'icon-icon_ling',
          label: '球标矩形',
          key: 'rectangle',
          isSign:true,
          type:'signRect'
        },
        {
          icon: 'icon-icon_fang',
          label: '球标菱形',
          key: 'rectangle',
          isSign:true,
          type:'signDiamond'
        }
      ]
    }
  },
  props: {
    editImgType: String
  },
  computed: {
    drawList() {
      let list = []
      if (this.editImgType == 'sphere') {
        //球标
        list = this.drawTypeDraw
      } else if (this.editImgType == 'sign') {
        //标记
        this.drawTypeDraw.forEach(element => {
          if (element.key.indexOf('sign') < 0) {
            list.push(element)
          }
        })
      }
      return list
    }
  },
  methods: {
    clickType(index, item) {
      this.currentIndex = index
      let config = {data:item}
      if (item.key == 'pen') {
        // config = { isDrawingMode: true }
        config.isDrawingMode=true
      } else if (item.key == 'select') {
        config = { drawType: '' }
      }
      this.$emit('setDrawConfig', config)
    }
  }
}
</script>

<style scoped lang='scss'>
.actived {
  background-color: #e34f51;
  color: white;
}
.left-type {
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-top: 1px solid #ccc;
  cursor: pointer;
}
.left-type:first-child {
  border-top: none;
}
.left-type:last-child {
  border-bottom: none;
}
</style>


// WEBPACK FOOTER //
// src/components/editImg/left.vue